'use strict';
import * as $j_app$002edata$002eauth$0024package$0024$002dIs$002dUser$002dAdmin$0024 from "./app.data.auth$package$-Is-User-Admin$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$13() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$13 as $c_Lapp_data_AppRegisteredUser$$anon$13 };
$c_Lapp_data_AppRegisteredUser$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$13.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$13;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$13() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$13 as $h_Lapp_data_AppRegisteredUser$$anon$13 };
$h_Lapp_data_AppRegisteredUser$$anon$13.prototype = $c_Lapp_data_AppRegisteredUser$$anon$13.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$13.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy8 = $j_app$002edata$002eauth$0024package$0024$002dIs$002dUser$002dAdmin$0024.$m_Lapp_data_auth$package$IsUserAdmin$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy8, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean);
});
$c_Lapp_data_AppRegisteredUser$$anon$13.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_data_AppRegisteredUser$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$13, "app.data.AppRegisteredUser$$anon$13", ({
  Lapp_data_AppRegisteredUser$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$13 as $d_Lapp_data_AppRegisteredUser$$anon$13 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$13.js.map
